import { HTTP } from '../../utils'

export const constructAdvancedQuery = (streamUuid, currentYear, currentSemester) => {
  let url = ''
  if (streamUuid && currentYear && currentSemester) {
    url = '/entity/courseBySemester/' + streamUuid + '/?currentYear=' + currentYear + '&currentSemester=' + currentSemester
  } else {
    return
  }
  return HTTP().get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const addEntityToStream = (streamUuid, courseData, currentYear, currentSemester, termCode, entityType, sendChannelMessage) => {
  let url = ''
  if (streamUuid && courseData && currentYear && currentSemester) {
    url = '/entity/addToSemester/' + streamUuid + '?currentYear=' + currentYear + '&currentSemester=' + currentSemester + '&sendChannelMessage=' + sendChannelMessage
  } else {
    return
  }
  if (entityType) {
    url += '&entityType=' + entityType
  }
  if (termCode) {
    url += '&termCode=' + termCode
  }
  return HTTP().post(url, courseData)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}



// WEBPACK FOOTER //
// ./src/app/advancedSearch/api.js